
export const withOffsets = (elements, fn, args) => {

    const {
        offset = 35,
        minOffset = 2,
        fullPositionsCount = 3,
    } = args;

    const collapsePositionsCount = elements.length - fullPositionsCount;

    const denominator = 16;

    return elements.map((e, index) => {

        const position = index+1;

        if(position > collapsePositionsCount){
            if(typeof fn === "function"){
                fn(e, offset);
            }
            return offset;
        }

        const collapsePosition = (elements.length - position);

        const numerator = denominator-collapsePosition;

        const fraction = numerator / denominator;

        const itemOffset = Math.floor(fraction * offset);
        const offsetResult = itemOffset <= minOffset ? minOffset : itemOffset;
        if(typeof fn === "function"){
            fn(e, offsetResult);
        }
        return offsetResult;
    });
};